import script from "./IntroSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroSplash.vue?vue&type=script&setup=true&lang=js"

import "./IntroSplash.vue?vue&type=style&index=0&id=6f40ad3e&lang=css"

const __exports__ = script;

export default __exports__